module.exports = __webpack_public_path__ + "static/img/pc.d71258c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/北京通州华仁学校/pc.svg
// module id = 3mDn
// module chunks = 16